import React, { useState, useEffect } from "react";
import {
    Accordion,
    AccordionSummary,
    Typography,
    makeStyles,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { connect } from "react-redux";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import { DataGrid } from "@material-ui/data-grid";

// Custom styles using Material-UI's makeStyles hook
const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        margin: "auto",
        maxWidth: 500,
    },
    accordion: {
        width: "fit-content",
        minWidth: "100%",
        marginTop: "10px",
        marginBottom: "10px",
        borderRadius: "5px",
        padding: "5px",
        "&::before": {
            height: "0",
        },
    },
    disabledRow: {
        color: "grey",
        "& .MuiDataGrid-cell": {
            color: "grey",
        },
        "& .MuiCheckbox-root": {
            color: "grey",
        }
    },
    heading: {
        fontWeight: "bold",
        fontSize: "1rem",
    }
}));

// Main component definition
const DataGridComponent = (props) => {
    const classes = useStyles();
    const {
        INWARDING_RECORD_ARRAY,
        COLUMNS,
        ORDER_ID,
        PAGE_SIZE,
        HANDLE_SELECTED_INWARDING_CHANGE,
        VENDOR_NAME,
        SELECTED_ITEMS,
    } = props;
    
    const [selectedRows, setSelectedRows] = useState([]);

    // Effect to update selected rows when SELECTED_ITEMS changes from parent
    useEffect(() => {
        if (SELECTED_ITEMS && SELECTED_ITEMS.length > 0) {
            // Get IDs of items that are in this accordion and are selected
            const selectedIds = INWARDING_RECORD_ARRAY
                .filter(item => 
                    SELECTED_ITEMS.some(selected => 
                        selected.inwardingRecordId?.toString() === item.inwardingRecordId?.toString()
                    )
                )
                .map(item => item.id);
            setSelectedRows(selectedIds);
        } else {
            setSelectedRows([]);
        }
    }, [SELECTED_ITEMS, INWARDING_RECORD_ARRAY]);

    // Function to handle selection change in the DataGrid
    const handleSelectionChange = (newSelection) => {
        props.setLoading(true);
        try {
            const selectionModel = newSelection.selectionModel || newSelection;
            let selectedInwardingArr = [...INWARDING_RECORD_ARRAY];

            for (let el of selectedInwardingArr) {
                if (selectionModel.includes(el.id)) {
                    el.isChecked = true;
                } else {
                    el.isChecked = false;
                }
            }
            
            setSelectedRows(selectionModel);
            HANDLE_SELECTED_INWARDING_CHANGE(selectedInwardingArr);
        } catch (error) {
            console.error("Error -> ", error);
        }
        props.setLoading(false);
    };

    // Function to check if row is selectable
    const checkIfRowIsSelectable = (params) => {
        try {
            return !params.row.isPaymentRaised;
        } catch (error) {
            console.error("Error -> ", error);
            return false;
        }
    };

    return (
        <Accordion className={classes.accordion} defaultExpanded={true}>
            <AccordionSummary
                className="iconposition"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
            >
                <Typography className={classes.heading}>
                    <b>{ORDER_ID || "N/A"}</b> | {VENDOR_NAME || "N/A"}
                </Typography>
            </AccordionSummary>
            <div style={{ width: "100%" }}>
                <DataGrid
                    rows={INWARDING_RECORD_ARRAY || []}
                    columns={COLUMNS || []}
                    pageSize={PAGE_SIZE || 10}
                    checkboxSelection
                    disableSelectionOnClick
                    disableColumnMenu={true}
                    hideFooterRowCount={false}
                    hideFooterSelectedRowCount={false}
                    selectionModel={selectedRows}
                    getRowClassName={(params) => params.row.isPaymentRaised === true ? `${classes.disabledRow}` : ""}
                    isRowSelectable={(params) => checkIfRowIsSelectable(params)}
                    autoHeight={true}
                    autoPageSize={true}
                    onSelectionModelChange={handleSelectionChange}
                />
            </div>
        </Accordion>
    );
};

export default connect(null, { setLoading, setSnackInfo })(DataGridComponent);